import { render, staticRenderFns } from "./SlsE_Details2.vue?vue&type=template&id=7d91f824"
import script from "./SlsE_Details2.vue?vue&type=script&lang=js"
export * from "./SlsE_Details2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports